module.exports = __webpack_public_path__ + "img/qr_code.87fcbf84.jpg";